import {
  Table,
  TableRow,
  TableHeader,
  TableHeaderCell,
  Text,
  TableBody,
  TableCell,
  Stack,
  Box,
} from 'braid-design-system';

import * as styles from '#src/components/mdx/mdxComponents.css.ts';

const buttonStyles = ['Accent', 'Light', 'Dark'];
const buttonSizes = ['Small', 'Standard'];

const buttonVariants = [
  {
    variant: 'Australia, New Zealand',
    brand: 'SEEK',
    locale: 'en',
  },
  {
    variant: 'Indonesia',
    brand: 'Jobstreet',
    locale: 'id',
  },
  {
    variant: 'Indonesia, Malaysia, Philippines, Singapore',
    brand: 'Jobstreet',
    locale: 'en',
  },
  {
    variant: 'Thailand',
    brand: 'Jobsdb',
    locale: 'th',
  },
  {
    variant: 'Hong Kong, Thailand',
    brand: 'Jobsdb',
    locale: 'en',
  },
];

export const ButtonModeTable = () => (
  <Table label="Button modes">
    <TableHeader>
      <TableRow>
        <TableHeaderCell>
          <Text>Variant</Text>
        </TableHeaderCell>
        <TableHeaderCell align="center">
          <Text>Small</Text>
        </TableHeaderCell>
        <TableHeaderCell align="center">
          <Text>Standard</Text>
        </TableHeaderCell>
      </TableRow>
    </TableHeader>
    <TableBody>
      {buttonVariants.map((buttonVariant, rowIndex) => (
        <TableRow key={rowIndex}>
          <TableCell align="center">
            <Stack space="small">
              <Text weight="medium">{buttonVariant.variant}</Text>
              <Text>{buttonVariant.locale}</Text>
            </Stack>
          </TableCell>
          {buttonSizes.map((size) => (
            <TableCell align="center" key={`${rowIndex}-${size}`}>
              <Stack space="small">
                {buttonStyles.map((style) => (
                  <Box
                    alt={`${size} ${style} themed Apply with ${buttonVariant.brand} button`}
                    className={styles.img.lightMode}
                    key={`${size}-${style}`}
                    src={`https://integration.seek.com/assets/awsk-button-assets/button-images/${buttonVariant.brand}/${buttonVariant.locale}/${size}-${style}.svg`.toLowerCase()}
                    component="img"
                  />
                ))}
              </Stack>
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  </Table>
);
